/**
 * CSV formula-injection guard (CONF-242, ASVS 5.3.2).
 *
 * A spreadsheet treats a cell that begins with `=`, `+`, `-`, `@`, a tab or a
 * carriage return as a formula, so free text such as a customer name or an
 * item description could execute when the BOM CSV is opened. Such a cell is
 * prefixed with an apostrophe, which the spreadsheet reads as "text".
 *
 * A plain number (`-5.00`) is not a formula, and the quote-explorer pipeline
 * parses the price columns numerically, so numeric strings are left alone.
 * Non-strings are returned unchanged. RFC 4180 quoting is still the CSV
 * writer's job (papaparse); this only decides the cell's content.
 */
const FORMULA_LEAD = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^-?\d+(\.\d+)?$/;

export function escapeCsvCell(value) {
  if (typeof value !== 'string') return value;
  if (!FORMULA_LEAD.test(value) || PLAIN_NUMBER.test(value)) return value;
  return `'${value}`;
}

export function escapeCsvRow(row) {
  const out = {};
  for (const key of Object.keys(row)) out[key] = escapeCsvCell(row[key]);
  return out;
}
